"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

import { Button } from "@/components/ui/button";

// Next catches a segment's render error before Sentry sees it, so the report
// is explicit; the page around this boundary (header, theme, fonts) survives.
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-2xl font-semibold">Something went wrong</h1>
      <p className="text-muted-foreground">
        This part of Keeps hit an error. Trying again usually fixes it.
      </p>
      <Button onClick={() => reset()}>Try again</Button>
    </main>
  );
}
